export const PUBLIC_LISTING_CONTRACT_VERSION = "public-listing.v1";

const contract = (value) => Object.freeze({
  contract: PUBLIC_LISTING_CONTRACT_VERSION,
  criticalLimit: 12,
  deferredLimit: 12,
  maxItems: 48,
  eagerImages: 2,
  ...value,
});

export const PUBLIC_LISTING_CONTRACTS = Object.freeze({
  home_stays: contract({ criticalLimit: 8, deferredLimit: 16, maxItems: 36, eagerImages: 3 }),
  home_experiences: contract({ criticalLimit: 8, deferredLimit: 16, maxItems: 36, eagerImages: 3 }),
  home_explore: contract({ criticalLimit: 6, deferredLimit: 18, maxItems: 36, eagerImages: 2 }),
  destinations: contract({ criticalLimit: 12, deferredLimit: 12, maxItems: 48 }),
  stays_camps: contract({ criticalLimit: 12, deferredLimit: 12, maxItems: 48 }),
  experiences: contract({ criticalLimit: 8, deferredLimit: 8, maxItems: 24 }),
  jungle_safaris: contract({ criticalLimit: 12, deferredLimit: 12, maxItems: 36 }),
  cruises: contract({ criticalLimit: 12, deferredLimit: 12, maxItems: 36 }),
  treks: contract({ criticalLimit: 12, deferredLimit: 12, maxItems: 36 }),
  districts: contract({ criticalLimit: 12, deferredLimit: 24, maxItems: 48, eagerImages: 2 }),
  packages: contract({ criticalLimit: 12, deferredLimit: 12, maxItems: 36, eagerImages: 2 }),
});

export const resolvePublicListingContract = (family = "") => (
  PUBLIC_LISTING_CONTRACTS[String(family || "").trim()] || contract({})
);

export const resolvePublicListingFamily = (pathname = "") => {
  const path = String(pathname || "/").replace(/\/+$/, "") || "/";
  if (["/", "/home", "/home/stays"].includes(path)) return "home_stays";
  if (path === "/home/experiences") return "home_experiences";
  if (["/home/explore", "/explore"].includes(path)) return "home_explore";
  if (path === "/destinations") return "destinations";
  if (path === "/stays-camps") return "stays_camps";
  if (path === "/experiences") return "experiences";
  if (path === "/jungle-safaris") return "jungle_safaris";
  if (path === "/cruise-boating") return "cruises";
  if (["/treks-trails", "/track-trails"].includes(path)) return "treks";
  if (path === "/districts") return "districts";
  if (path === "/packages") return "packages";
  return "";
};

const identityFor = (item, index) => String(
  item?.id || item?._id || item?.slug || item?.code || item?.key || `index:${index}`,
);

export const mergeBoundedListingItems = (current = [], incoming = [], maxItems = 48) => {
  const result = [];
  const seen = new Set();
  [...(Array.isArray(current) ? current : []), ...(Array.isArray(incoming) ? incoming : [])]
    .forEach((item, index) => {
      if (!item || result.length >= Math.max(1, Number(maxItems) || 48)) return;
      const identity = identityFor(item, index);
      if (seen.has(identity)) return;
      seen.add(identity);
      result.push(item);
    });
  return result;
};

export const extractPublicListingPage = (response) => {
  const items = Array.isArray(response?.data?.items)
    ? response.data.items
    : Array.isArray(response?.items)
      ? response.items
      : Array.isArray(response?.data)
        ? response.data
        : [];
  const meta = response?.meta || {};
  const nextCursor = meta.nextCursor || null;
  const page = Math.max(1, Number(meta.page || response?.page || 1) || 1);
  const total = Number(meta.total ?? response?.total ?? items.length) || items.length;
  const limit = Math.max(1, Number(meta.limit || response?.limit || items.length || 1) || 1);
  const computedTotalPages = Math.max(1, Math.ceil(total / limit));
  const totalPages = Math.max(
    page,
    Number(meta.totalPages || response?.totalPages || computedTotalPages) || page,
  );
  const hasMore = Boolean(
    (meta.hasMore && nextCursor)
    || (!nextCursor && page < totalPages),
  );
  return {
    items,
    meta,
    nextCursor,
    nextPage: !nextCursor && page < totalPages ? page + 1 : null,
    hasMore,
    total,
    facets: response?.data?.facets || response?.facets || null,
  };
};
